const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    pair: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {
       
        case 'PAIR_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                pair: action.payload
        };
      
        case 'PAIR_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                pair: action.payload,
            };
        case 'PAIR_CURRENT_ROLE':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                pair: action.payload
            };  
            
        case 'PAIR_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}
